import React, { Component } from "react";
import { Link } from "react-router-dom";
import { logout } from "service/utilities";
import { Logout } from "redux/actions/auth";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { login, getTokenDetails } from "redux/actions/auth";
import "./style.scss";
import closeIcon from "assets/images/close.png";
import { NormalButton, NormalInput, NormalModal } from "component/common";
import { Toast } from "service/toast";
import UserImage from "assets/images/user-image.png";
import { commonCreateApi, getCommonApi } from "redux/actions/common";
import { withTranslation } from "react-i18next";
export class ProfileMenuClass extends Component {
  state = {
    navLinks: [
      {
        to: "/admin/editUserProfile",
        label: "Edit Profile",
        iconName: "Group-81",
        typeId: [1, 2],
      },
      {
        to: "/admin/adminManagement",
        label: "Admin Management",
        iconName: "Group-59",
        typeId: [1],
      },
    ],
    dropDownSwitchUsers: [],
    dropDownSwitchSites: [],
    isOpenModal: false,
    userPassword: "",
    userName: "",
    itemsite_code: "",
    isChangePassword: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    newPasswordVisible: false,
    currentPasswordVisible: false,
    confirmPasswordVisible: false,
    passwordComplexity: {},
  };

  handleLogout = () => {
    this.props.Logout().then((res) => {
      if (res.status === 200) {
        logout();
      }
    });
  };

  // handleCloseModal
  handleCloseModal = () => {
    this.setState({ isOpenModal: false, userPassword: "", itemsite_code: "" });
  };

  // inital Token get
  componentDidMount = () => {
    setTimeout(() => {
      let { switch_sites, switch_users, userswitch, username } =
        this.props.tokenDetails;
      this.setState({ userName: username });
      if (userswitch && switch_users.length > 0) {
        this.setState({ dropDownSwitchUsers: switch_users });
      }
      if (userswitch && switch_sites.length > 0) {
        this.setState({ dropDownSwitchSites: switch_sites });
      }
    }, 2000);
  };

  // handleSwitchUser
  handleSwitchUser = async (userName, id = "") => {
    debugger;
    await this.setState({
      userName: id ? this.state.userName : userName,
      userPassword: "",
      itemsite_code: id,
    });
    await this.setState({ isOpenModal: true });
  };

  // handleChange
  handleChange = async (event) => {
    await this.setState({
      [event.target.name]: event.target.value,
    });
    // this.setState({ userPassword: e.target.value });
  };

  // handleSwitchSubmit
  handleauthentication = async () => {
    let { logined_siteid } = this.props.tokenDetails;
    let { userName, userPassword, itemsite_code } = this.state;
    let validatePassword = this.validatePassword(userPassword);
    if (validatePassword) {
      let payload = {
        salon: itemsite_code ? itemsite_code : logined_siteid,
        username: userName,
        password: userPassword,
      };
      this.props.login(payload).then((res) => {
        let { status } = res;
        if (status === 200) {
          this.props.getTokenDetails().then((res) => {
            {
              if (res) {
                this.setState({ isOpenModal: false });
                window.location.reload();
              }
            }
          });
        }
      });
    }
  };

  // validatePassword
  validatePassword = (pass) => {
    if (pass.length === 0) {
      Toast({
        type: "error",
        message: "Enter Password ",
      });
      return false;
    } else if (pass.length <= 2) {
      Toast({
        type: "error",
        message: "Password greater than  2 characters",
      });
      return false;
    } else {
      return true;
    }
  };

  handleInputChange = async (event) => {
    await this.setState({
      [event.target.name]: event.target.value,
    });
  };

  toggle = (key) => {
    this.setState((prevState) => ({
      [key]: !prevState[key],
    }));
  };

  handleDialog = () => {
    let { isChangePassword } = this.state;
    isChangePassword = !isChangePassword;
    this.setState({
      isChangePassword,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };

  toggle = (key) => {
    this.setState((prevState) => ({
      [key]: !prevState[key],
    }));
  };
  handleChangePasswordDialog = () => {
    this.setState({
      isChangePassword: true,
    });
    this.props.getCommonApi("passwordrequirements/").then((res) =>
      this.setState({
        passwordComplexity: res,
      })
    );
  };

  validateNewPassword = (password) => {
    const { passwordComplexity } = this.state;

    if (!passwordComplexity) {
      return "Password complexity requirements are not loaded.";
    }

    const validationRules = {
      minLength: (pw, value) => pw.length >= value,
      minUpperCase: (pw, value) => (pw.match(/[A-Z]/g) || []).length >= value,
      minLowerCase: (pw, value) => (pw.match(/[a-z]/g) || []).length >= value,
      minDigits: (pw, value) => (pw.match(/\d/g) || []).length >= value,
      minSpecialChars: (pw, value) =>
        (pw.match(/[!@#$%^&*(),.?":{}|<>]/g) || []).length >= value,
    };

    for (const [key, value] of Object.entries(passwordComplexity)) {
      if (
        key.includes("Minimum Length") &&
        !validationRules.minLength(password, value)
      ) {
        return Toast({
          type: "error",
          message: `Password must be at least ${value} characters long.`,
        });
      }
      if (
        key.includes("Minimum Uppercase Chars") &&
        !validationRules.minUpperCase(password, value)
      ) {
        return Toast({
          type: "error",
          message: `Password must contain at least ${value} uppercase letter(s).`,
        });
      }
      if (
        key.includes("Minimum Lowercase Chars") &&
        !validationRules.minLowerCase(password, value)
      ) {
        return Toast({
          type: "error",
          message: `Password must contain at least ${value} lowercase letter(s).`,
        });
      }
      if (
        key.includes("Minimum Digits Char") &&
        !validationRules.minDigits(password, value)
      ) {
        return Toast({
          type: "error",
          message: `Password must contain at least ${value} digit(s).`,
        });
      }
      if (
        key.includes("Minimum Special Chars") &&
        !validationRules.minSpecialChars(password, value)
      ) {
        return Toast({
          type: "error",
          message: `Password must contain at least ${value} special character(s).`,
        });
      }
    }

    return null;
  };

  handleChangePassword = () => {
    let { newPassword, currentPassword, confirmPassword } = this.state;
    const errorMsg = this.validateNewPassword(newPassword);

    if (errorMsg === null) {
      if (newPassword !== confirmPassword) {
        return Toast({
          type: "error",
          message: `New password and Confirm Password doesn't match`,
        });
      }

      let requestBody = {
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };
      console.log(errorMsg, "error");
      this.props
        .commonCreateApi(`change_password/`, requestBody)
        .then((res) => {
          this.setState({
            isChangePassword: false,
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
          Toast({
            type: "error",
            message: `Password Changed Successfully`,
          });
        });
    }
  };
  render() {
    let {
      navLinks,
      dropDownSwitchUsers,
      isOpenModal,
      passwordVisible,
      userPassword,
      userName,
      dropDownSwitchSites,
      itemsite_code,
      isChangePassword,
      currentPassword,
      newPassword,
      confirmPassword,
      currentPasswordVisible,
      newPasswordVisible,
      confirmPasswordVisible,
      passwordComplexity,
    } = this.state;

    let { typeId } = this.props.data;
    let { t } = this.props;
    let tokentypeId = typeId;

    return (
      <>
        <div className={`profile-menu ${this.props.active ? "active" : ""}`}>
          <ul>
            {navLinks.map((item, index) => {
              let { to, label, iconName, typeId } = item;

              return (
                <React.Fragment key={index}>
                  {typeId.indexOf(tokentypeId) != -1 ? (
                    <li>
                      <Link to={to}>
                        <span
                          className={`profile-menu-icon icon-${iconName}`}
                        ></span>
                        <span className="profile-menu-desc">{label}</span>
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              );
            })}

            {/* <li>
            <a onClick={logout} href="#">
              <span className="profile-menu-icon icon-Group-33"></span>
              <span className="profile-menu-desc">Logout</span>
            </a>
          </li> */}
            <li>
              <span className="">{this.props.data.username}</span>
            </li>
            <li>
              <span className="">({this.props.data.role})</span>
            </li>

            <li>
              <a onClick={this.handleChangePasswordDialog} href="#">
                {/* <span className="profile-menu-icon icon-logout"></span> */}
                <span className="profile-menu-desc">Change Password</span>
              </a>
            </li>
            <li>
              <a onClick={this.handleLogout} href="#">
                <span className="profile-menu-icon icon-logout"></span>
                <span className="profile-menu-desc">Logout</span>
              </a>
            </li>

            {dropDownSwitchUsers && dropDownSwitchUsers.length > 0 && (
              <li>
                <h6 className="my-2">Switch Users</h6>

                <div className="profileMenuSwithUser">
                  {dropDownSwitchUsers &&
                    dropDownSwitchUsers.length > 0 &&
                    dropDownSwitchUsers.map((item, id) => {
                      return (
                        <div
                          key={id}
                          className="profileMenuContainer"
                          onClick={() =>
                            this.handleSwitchUser(item.pw_userlogin, "")
                          }
                        >
                          <div className="profileImgContainer">
                            <img
                              className="border-radius-circle userProfile w-100 h-100"
                              src={UserImage}
                              alt="User"
                            />
                          </div>

                          <h6 key={id} className="menuSwitchTitle">
                            {item.pw_userlogin}
                          </h6>
                        </div>
                      );
                    })}
                </div>
              </li>
            )}
            {dropDownSwitchSites && dropDownSwitchSites.length > 0 && (
              <li>
                <h6 className="my-2">Switch Sites</h6>

                <div className="profileMenuSwithUser">
                  {dropDownSwitchSites &&
                    dropDownSwitchSites.length > 0 &&
                    dropDownSwitchSites.map((item, id) => {
                      return (
                        <div
                          key={id}
                          className="profileMenuContainer"
                          onClick={() =>
                            this.handleSwitchUser(item.itemsite_desc, item.id)
                          }
                        >
                          <div className="profileImgContainer">
                            <img
                              className="border-radius-circle userProfile w-100 h-100"
                              src={UserImage}
                              alt="User"
                            />
                          </div>

                          <h6 key={id} className="menuSwitchTitle">
                            {item.itemsite_desc}
                          </h6>
                        </div>
                      );
                    })}
                </div>
              </li>
            )}
          </ul>

          <NormalModal
            className="profileMenuAuthModal"
            modal={isOpenModal}
            handleModal={this.handleCloseModal}
          >
            <div className="row">
              <div className="d-flex flex-wrap">
                <div className="col-12 mb-4">
                  <p>{`Switch to  ${itemsite_code ? "Site" : "User"} `} </p>
                </div>
                <div className="col-12 form-group mb-3 pb-2">
                  <div className="input-group">
                    <NormalInput
                      placeholder="Username"
                      value={userName}
                      name="userName"
                      autocomplete="off"
                      onChange={this.handleChange}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-12 form-group mb-3 pb-2">
                  <div className="input-group">
                    <NormalInput
                      type={passwordVisible ? "text" : "password"}
                      placeholder="Password"
                      value={userPassword}
                      name="userPassword"
                      autocomplete="off"
                      onChange={this.handleChange}
                    />
                    <div className="input-group-addon right fs-14">
                      <span
                        onClick={() => this.toggle("passwordVisible")}
                        className={`icon-${
                          passwordVisible ? "eye" : "eye-blocked"
                        } cursor-pointer fs-24`}
                      ></span>
                    </div>
                  </div>
                </div>
                <div className="form-group mb-0 p-0 d-flex justify-content-center col-12">
                  <NormalButton
                    onClick={() => this.handleauthentication()}
                    label="PROCEED"
                    className="col-12 submit-btn"
                  />
                </div>
              </div>
            </div>
          </NormalModal>
        </div>
        <NormalModal
          className={"multiple-appointment select-category"}
          style={{ minWidth: "800px" }}
          modal={isChangePassword}
          handleModal={this.handleDialog}
        >
          <img
            onClick={this.handleDialog}
            className="close"
            src={closeIcon}
            alt=""
          />
          <div className="row mt-2 mb-5 mx-3">
            <div className="col-12 pl-0 mb-3 fs-18 py-2">
              {t("Change Password")}
            </div>
            {/* <div className="col-12 form-group mb-3 pb-2"> */}

            <div className="col-5 pl-0">
              {t("Please key in current password")}
            </div>
            <div className="col-7">
              <div className="password-input-group">
                <NormalInput
                  type={currentPasswordVisible ? "text" : "password"}
                  placeholder="Password"
                  value={currentPassword}
                  name="currentPassword"
                  onChange={this.handleChange}
                />
                <div className="password-input-icon fs-14">
                  <span
                    onClick={() => this.toggle("currentPasswordVisible")}
                    className={`icon-${
                      currentPasswordVisible ? "eye" : "eye-blocked"
                    } cursor-pointer fs-24`}
                  ></span>
                </div>
                {/* {t(" ")} */}
              </div>
              {/* {t(" ")} */}
            </div>

            <div className="col-5 pl-0">{t("Please key in New password")}</div>
            <div className="col-7">
              <div className="password-input-group">
                <NormalInput
                  type={newPasswordVisible ? "text" : "password"}
                  placeholder="Password"
                  value={newPassword}
                  name="newPassword"
                  onChange={this.handleChange}
                />
                <div className="password-input-icon fs-14">
                  <span
                    onClick={() => this.toggle("newPasswordVisible")}
                    className={`icon-${
                      newPasswordVisible ? "eye" : "eye-blocked"
                    } cursor-pointer fs-24`}
                  ></span>
                </div>
                {/* {t(" ")} */}
              </div>
              {/* {t(" ")} */}
            </div>
            <div className="col-5 pl-0">{t("Please Confirm  password")}</div>
            <div className="col-7">
              <div className="password-input-group">
                <NormalInput
                  type={confirmPasswordVisible ? "text" : "password"}
                  placeholder="Password"
                  value={confirmPassword}
                  name="confirmPassword"
                  onChange={this.handleChange}
                />
                <div className="password-input-icon fs-14">
                  <span
                    onClick={() => this.toggle("confirmPasswordVisible")}
                    className={`icon-${
                      confirmPasswordVisible ? "eye" : "eye-blocked"
                    } cursor-pointer fs-24`}
                  ></span>
                </div>
                {/* {t(" ")} */}
              </div>
              {/* {t(" ")} */}
            </div>

            <div>
              <div>
                <p className="mb-2">
                  {t("Password Complexity Requirements")} :
                </p>

                {passwordComplexity &&
                  Object.entries(passwordComplexity).map(([key, value]) => (
                    <div key={key}>
                      <span>{t(key.replace(/_/g, " "))}: </span>
                      <strong className="ms-3">{value}</strong>
                    </div>
                  ))}
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex justify-content-end mt-3 ">
                <div className="mr-3">
                  <NormalButton label="Cancel" onClick={this.handleDialog} />
                </div>
                <NormalButton
                  label="Confirm"
                  className="col-12 submit-btn"
                  onClick={this.handleChangePassword}
                />
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      Logout,
      login,
      getTokenDetails,
      getCommonApi,
      commonCreateApi,
    },
    dispatch
  );
};

export const ProfileMenu = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ProfileMenuClass)
);
